import AbuseReports from './AbuseReports'
import AbuseReport from './AbuseReport'
import { makeEntityExistsGuard } from '@/store/utils'

export default [
  { path: '/moderation', name: 'moderation', component: AbuseReports },
  { path: '/moderation/:id',
    name: 'abuse-report',
    component: AbuseReport,
    beforeEnter: makeEntityExistsGuard('abuseReports')
  }
]



// WEBPACK FOOTER //
// ./src/components/moderation/routes.js